import { useIsCreativeLibraryModule } from 'modules/creative-library/hooks/useIsCreativeLibraryModule';
import { FEATURE_FLAGS, useConfigMatch } from 'modules/taboola-common-frontend-modules/account-configurations';
import { useFormFieldValue } from 'modules/taboola-common-frontend-modules/formData';

export const useIsCreativeLibrary = () => {
    const isCreativeLibraryEnabled = useConfigMatch({ [FEATURE_FLAGS.CREATIVE_LIBRARY_ENABLED]: 'true' });
    const isCreativeLibraryModule = useIsCreativeLibraryModule();
    const { value: isCreativeLibrary } = useFormFieldValue({ field: 'isCreativeLibrary' });

    return {
        isCreativeLibraryEnabled,
        isCreativeLibraryModule,
        isCreativeLibraryCampaign: isCreativeLibrary,
    };
};
